import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SignUpForm from '../SignUpForm';
import Stack from '../../../components/stack/Stack';
import { Button } from '@helsingborg-stad/municipio-react-ui';
export const Pending = (props) => {
    var _a;
    return (_jsx(SignUpForm, Object.assign({ volunteer: Object.assign({
            firstName: '',
            lastName: '',
            id: '',
            email: '',
            phone: '',
            status: '',
        }, ((_a = props.volunteer) !== null && _a !== void 0 ? _a : {})), onSubmit: () => { } }, { children: _jsxs(Stack, Object.assign({ spacing: 3 }, { children: [_jsx(Button, Object.assign({ className: 'c-button__full-width', disabled: true, color: 'primary' }, { children: props.disabledButtonLabel })), _jsx(Button, Object.assign({ className: 'c-button__full-width', disabled: true, color: 'secondary', onClick: props.onClickClose }, { children: props.logoutButtonLabel }))] })) })));
};
